import React from "react";

import { cn } from "@/lib/utils";

export const SkeletonBar: React.FC<{ className?: string; label?: string }> = ({
  className,
  label,
}) => (
  <span
    className={cn(
      "inline-block align-middle rounded-md bg-slate-100 dark:bg-slate-800 motion-safe:animate-pulse",
      className,
    )}
  >
    {label && <span className="sr-only">{label}</span>}
  </span>
);
